import React from "react";
import { connect } from "react-redux";
import "./App.css";

import AppSuperBar from './components/AppSuperBar';
import {
  Switch,
  Route,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Consultas from './components/Consultas';
import Titulo from './components/Titulo';
import Especialidad from './components/Especialidad'
import MediAseguradora from './components/MediacionAseguradora'
import Comprobante from './components/Comprobante'
import MediPrestadores from './components/MediacionPrestadores'
import LoginMat from './components/LoginMat/LoginMat';
import LoginClaveUnica from './components/LoginClaveUnica'
import PrivateRoute from './components/routers/PrivateRoute/';
import LoginNSerie from './components/LoginNSerie'
import ReactGA from 'react-ga';
import { GA_TRACKING_CODE_UA } from "./config/config";
const TRACKING_ID = GA_TRACKING_CODE_UA; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
console.log("linea 25 ",TRACKING_ID )

function App() {
  return (

    <div className="App" style={{ position: 'absolute', left: '0px', width: '100%' }}>
      <AppSuperBar />
      <ToastContainer />
      <Switch>
        <Route exact path="/login" component={LoginMat} />
        <PrivateRoute path="/Consultas" component={Consultas} />
        <PrivateRoute path="/Titulo" component={Titulo} />
        <PrivateRoute path="/Especialidad" component={Especialidad} />
        <PrivateRoute path="/MediacionAseguradora" component={MediAseguradora} />
        <PrivateRoute path="/Comprobante" component={Comprobante} />
        <PrivateRoute path="/MediacionPrestadores" component={MediPrestadores} />
        <Route path="/validacion" component={LoginClaveUnica} />
        <Route path="/validacionRut" component={LoginNSerie} />
        <Route path="/" component={LoginMat} />
        
      </Switch>

    </div>

  );
}

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};


export default connect(mapStatetoProps)(App);
